import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import service from '../services';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Radio from '@material-ui/core/Radio';
import MessageModal from '../../../UI/Modal/MessageModal';
import CardHeader from '@material-ui/core/CardHeader';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import Table from '@material-ui/core/Table';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const useStyles = makeStyles({
    root: {
        minWidth: 50,
        flexGrow: 1
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});

const SimpleCard = forwardRef((props, ref) => {
    const classes = useStyles();
    const bull = <span className={classes.bullet}>•</span>;

    const { collectionPointID, date } = props;

    const [unresolvedTags, setUnresolvedTags] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [open2, setOpen2] = React.useState(false);
    const [selectedTag, setSelectedTag] = useState({});
    const [selectedTagList, setSelectedTagList] = useState([]);
    const [regNumber, setRegNumber] = useState('');
    const [unMatchedList, setUnMatchedList] = useState([]);
    const [fieldRadio, setFieldRadio] = useState('');
    const [factoryRadio, setFactoryRadio] = useState('');
    const [isMatchDisabled, setIsMatchDisabled] = useState(true);
    const [isTableDisabled, setTableDisabled] = useState(true);
    const [isRegButtonDisabled, setRegButtonDisabled] = useState(true);
    const [matchedTagList, setMatchedTagList] = useState([]);
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    const contentRowNames = [
        { title: "Tag Number", field: "tagNumber" },
        { title: "gross Amount", field: "grossAmount" },
        { title: "net Amount", field: "netAmount" }
    ]

    useEffect(() => {
        //getAllUnResolvedFactoryWeighExceptionsByCP()
        //setUnresolvedTags(unResolveTags.unResolvedExceptions);
        //setUnMatchedList(unResolveTags.unMatchedTags)
    }, []);

    useEffect(() => {
        if (fieldRadio !== '' && factoryRadio !== '') {
            setIsMatchDisabled(false);
        }
        else {
            setIsMatchDisabled(true);
        }
    }, [fieldRadio, factoryRadio]);

    useEffect(() => {
        if (regNumber !== '') {
            setRegButtonDisabled(false);
        }
        else {
            setRegButtonDisabled(true);
        }
    }, [regNumber]);

    useImperativeHandle(ref, () => ({

        hanldeSearch() {
            getAllUnResolvedFactoryWeighExceptionsByCP(collectionPointID, date);
        },
        clearData() {
            clearHookData();
        }

    }));

    const handleClickOpen = (tag) => {
        setSelectedTag(tag);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setRegNumber('');
    };

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    async function getAllUnResolvedFactoryWeighExceptionsByCP(collectionPointID, date) {
        const unresolvedTagsResponse = await service.getAllUnResolvedFactoryWeighExceptionsByCP(collectionPointID, date);
        if (unresolvedTagsResponse.unResolvedExceptions.length === 0 && unresolvedTagsResponse.unMatchedTags.length === 0) {
            setMessageModel({ ...messageModel, hidden: false, type: 'Warning', disciption: 'No data found' });
            setTableDisabled(true);
        }

        setUnresolvedTags(unresolvedTagsResponse.unResolvedExceptions);
        setUnMatchedList(unresolvedTagsResponse.unMatchedTags);
        setTableDisabled(false);
    }

    const onAddRegNumber = (selectedTag) => {
        let tags = [...selectedTagList];
        let unResTags = [...unresolvedTags];

        selectedTag['regNumber'] = regNumber;
        tags.push(selectedTag);

        let updatedUnresTags = unResTags.filter(x => x.factoryExceptionID != selectedTag.factoryExceptionID);

        setSelectedTagList(tags);
        setUnresolvedTags(updatedUnresTags);
        setOpen(false);
        setRegNumber('');
    }

    const handleRegNumberChange = (target) => {
        setRegNumber(target.value);
    }

    const onRemoveFactory = (tag) => {
        let unResTags = [...unresolvedTags];
        let selectedTags = [...selectedTagList];

        let updatedSelectedTags = selectedTags.filter(x => x.factoryExceptionID != selectedTag.factoryExceptionID);

        unResTags.push(tag);
        setSelectedTagList(updatedSelectedTags);
        setUnresolvedTags(unResTags);
    }

    const handleFieldRadioChange = (tag) => {
        let fieldExceptionID = tag.productCollectionDetailsID;
        setFieldRadio(fieldExceptionID);
    }

    const handleFactoryRadioChange = (tag) => {
        let fieldExceptionID = tag.factoryExceptionID;

        setFactoryRadio(fieldExceptionID);
    }

    const onFactoryRadioClick = (tag) => {
        let fieldExceptionID = tag.factoryExceptionID;

        if (fieldExceptionID === factoryRadio) {
            setFactoryRadio('');
        }
    }

    const onFieldRadioClick = (tag) => {
        let fieldExceptionID = tag.productCollectionDetailsID;

        if (fieldExceptionID === fieldRadio) {
            setFieldRadio('');
        }
    }

    const onMatchClicked = () => {
        let matchedTags = [...matchedTagList];
        let unMatchTags = [...unMatchedList];
        let unResTags = [...unresolvedTags]

        let matchedTag = unMatchTags.find(x => x.productCollectionDetailsID == fieldRadio);
        let matchedUnResTag = unResTags.find(x => x.factoryExceptionID == factoryRadio);

        matchedTag.factoryExceptionID = matchedUnResTag.factoryExceptionID;
        matchedTag.factoryWeighDetailID = matchedUnResTag.factoryWeighDetailID;
        matchedTag['prevValue'] = JSON.stringify(matchedUnResTag);

        let updatedMatchTags = unMatchTags.filter(x => x.productCollectionDetailsID != fieldRadio);

        let updatedUnResTags = unResTags.filter(x => x.factoryExceptionID != factoryRadio);

        matchedTags.push(matchedTag);
        setMatchedTagList(matchedTags);
        setUnresolvedTags(updatedUnResTags);
        setUnMatchedList(updatedMatchTags);
        setFieldRadio('');
        setFactoryRadio('');
    }

    const onRemoveField = (tag) => {
        let unResTags = [...unresolvedTags];
        let unMatchTags = [...unMatchedList];
        let matchedTags = [...matchedTagList];

        let updatedMatchedTag = matchedTags.filter(x => x.factoryExceptionID != tag.factoryExceptionID);

        let unResTag = JSON.parse(tag.prevValue);

        let unMatchTag = {
            grossAmount: tag.grossAmount,
            actualAmount: tag.actualAmount,
            netAmount: tag.netAmount,
            totalDeduction: tag.totalDeduction,
            tagNumber: tag.tagNumber,
            factoryWeighDetailID: '00000000-0000-0000-0000-000000000000',
            productCollectionDetailsID: tag.productCollectionDetailsID,
            factoryExceptionID: 0,
            regNumber: tag.regNumber
        };

        unResTags.push(unResTag);
        unMatchTags.push(unMatchTag);

        setMatchedTagList(updatedMatchedTag);
        setUnresolvedTags(unResTags);
        setUnMatchedList(unMatchTags);
    }

    const onSubmit = (async () => {
        const response = await service.resolveTagExceptions(collectionPointID, date, selectedTagList, matchedTagList);
        console.log(response);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });

        if (response.statusCode === 'Success') {
            clearHookData();
        }
    });

    async function registerAddBoxData() {
        selectedTag.forEach(x => {
            x.tagNumber = x.tagNumber;
            x.grossAmount = x.grossAmount.toFixed(2);
            x.netAmount = x.netAmount.toFixed(2);
            x.totalDeduction = x.totalDeduction.toFixed(2);
        });
    }
    function clearHookData() {
        setTableDisabled(true)
        setUnresolvedTags([]);
        setUnMatchedList([]);
        setSelectedTagList([]);
        setMatchedTagList([]);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    return (
        <div>
            <Grid container justify="space-between" hidden={isTableDisabled}>
                <Box width={2 / 4}>
                    <Card className={classes.root}>
                        <CardHeader title="Tag Details - Factory" className={classes.heading} style={{ textAlign: 'center' }} />
                        <CardContent>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Select</TableCell>
                                        <TableCell align="left" style={{ fontWeight: "bold" }}>Tag Number</TableCell>
                                        <TableCell align="right" style={{ fontWeight: "bold" }}>Gross (Kg)</TableCell>
                                        <TableCell align="right" style={{ fontWeight: "bold" }}>Net (Kg)</TableCell>
                                        <TableCell align="right" style={{ fontWeight: "bold" }}>Deductions (Kg)</TableCell>
                                        <TableCell align="right" style={{ fontWeight: "bold" }}>Edit</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {unresolvedTags.map((row) => (
                                        <TableRow>
                                            <TableCell align="center">
                                                <Radio checked={factoryRadio === row.factoryExceptionID} onClick={() => onFactoryRadioClick(row)}
                                                    onChange={() => handleFactoryRadioChange(row)}
                                                    value={row.factoryExceptionID} name="factory-radio" inputProps={{ 'aria-label': 'A' }} />
                                            </TableCell>
                                            <TableCell align="left">{row.tagNumber}</TableCell>
                                            <TableCell align="right">{row.grossAmount.toFixed(2)}</TableCell>
                                            <TableCell align="right">{row.netAmount.toFixed(2)}</TableCell>
                                            <TableCell align="right">{row.totalDeduction.toFixed(2)}</TableCell>
                                            <TableCell align="right">
                                                <Button disabled={factoryRadio == row.factoryExceptionID} variant="contained" color="primary" onClick={() => handleClickOpen(row)} > Edit </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </Box>
                <Box width={2 / 4}>
                    <Card className={classes.root}>
                        <CardHeader title="Tag Details - Field" className={classes.heading} style={{ textAlign: 'center' }} />
                        <CardContent>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Select</TableCell>
                                        <TableCell align="left" style={{ fontWeight: "bold" }}>Tag Number</TableCell>
                                        <TableCell align="right" style={{ fontWeight: "bold" }}>Gross (Kg)</TableCell>
                                        <TableCell align="right" style={{ fontWeight: "bold" }}>Net (Kg)</TableCell>
                                        <TableCell align="right" style={{ fontWeight: "bold" }}>Deductions (Kg)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {unMatchedList.map((row) => (
                                        <TableRow>
                                            <TableCell align="center">
                                                <Radio checked={fieldRadio === row.productCollectionDetailsID} onClick={() => onFieldRadioClick(row)}
                                                    onChange={() => handleFieldRadioChange(row)}
                                                    value={row.productCollectionDetailsID} name="field-radio" inputProps={{ 'aria-label': 'A' }} />
                                            </TableCell>
                                            <TableCell align="left">{row.tagNumber}</TableCell>
                                            <TableCell align="right">{row.grossAmount.toFixed(2)}</TableCell>
                                            <TableCell align="right">{row.netAmount.toFixed(2)}</TableCell>
                                            <TableCell align="right">{row.totalDeduction.toFixed(2)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </Box>
            </Grid>

            <div className="card-footer">
                <input
                    hidden={isTableDisabled}
                    type="button"
                    onClick={() => onMatchClicked()}
                    className="btn btn-primary"
                    value="Match"
                    disabled={isMatchDisabled}
                />
            </div>


            {selectedTagList.length == 0 && matchedTagList.length == 0 ? null : <div className="table-responsive row-top-gap">
                <table id="example" className="display dataTable no-footer">
                    <thead>
                        <tr>
                            <th>Registration Number</th>
                            <th>Tag Number</th>
                            <th>Gross Weight</th>
                            <th>Net Weight</th>
                            <th>Deductions</th>
                            <th>Remove</th>
                        </tr>
                    </thead>
                    <tbody>
                        {selectedTagList.map((tag, i) => {
                            return (
                                <tr key={i}>
                                    <td>{tag.regNumber}</td>
                                    <td>{tag.tagNumber}</td>
                                    <td>{tag.grossAmount.toFixed(2)}</td>
                                    <td>{tag.netAmount.toFixed(2)}</td>
                                    <td>{tag.totalDeduction.toFixed(2)}</td>
                                    <td> <IconButton onClick={() => onRemoveFactory(tag)}>  <DeleteIcon /> </IconButton> </td>
                                </tr>
                            )

                        })}

                        {matchedTagList.map((tag, i) => {
                            return (
                                <tr key={i}>
                                    <td>{tag.regNumber}</td>
                                    <td>{tag.tagNumber}</td>
                                    <td>{tag.grossAmount.toFixed(2)}</td>
                                    <td>{tag.netAmount.toFixed(2)}</td>
                                    <td>{tag.totalDeduction.toFixed(2)}</td>
                                    <td> <IconButton onClick={() => onRemoveField(tag)}>  <DeleteIcon /> </IconButton> </td>
                                </tr>
                            )

                        })}

                    </tbody>
                </table>
            </div>}

            {selectedTagList.length == 0 && matchedTagList.length == 0 ? null : <div className="card-footer">
                <input
                    type="button"
                    onClick={handleClickOpen2}
                    className="btn btn-primary"
                    value="Upload"
                />
            </div>}
            
            <Dialog
                open={open2}
                onClose={handleClose2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Warning !"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure about this?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose2}>No</Button>
                    <Button onClick={() => onSubmit()} autoFocus>Yes</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Add Registration Number</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography variant="subtitle1" component="div">
                            Tag Number : {selectedTag.tagNumber}
                        </Typography>
                        <Typography variant="subtitle1" component="div">
                            Gross (Kg) : {selectedTag.grossAmount}
                        </Typography>
                        <Typography variant="subtitle1" component="div">
                            Net (Kg) : {selectedTag.netAmount}
                        </Typography>
                        <Typography variant="subtitle1" component="div">
                            Deductions (Kg) : {selectedTag.totalDeduction}
                        </Typography>
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Registration Number"
                        type="text"
                        fullWidth2
                        onChange={(e) => handleRegNumberChange(e.target)}
                        value={regNumber}
                    />
                </DialogContent>
                <div className="card-footer">
                    <input
                        disabled={isRegButtonDisabled}
                        type="button"
                        onClick={() => onAddRegNumber(selectedTag)}
                        className="btn btn-primary"
                        value="Add"
                    />
                </div>
            </Dialog>

            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </div>



    );
})

export default SimpleCard;

